module.exports = __webpack_public_path__ + "img/logo_wb.e16e52e0.png";